import React from 'react';
import { Input } from '../../components/ui/input';
import { MapPin, X } from 'lucide-react';
import { mockLocations } from '../../mock';

const StopManager = ({
  stops,
  showStopSuggestions,
  setShowStopSuggestions,
  onAddStop,
  onRemoveStop,
  onUpdateStop
}) => {
  return (
    <>
      {stops.map((stop, index) => (
        <div key={index} className="relative mt-4">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-orange-500"></div>
            <div className="flex-1 flex gap-2">
              <div className="flex-1 relative">
                <Input
                  placeholder={`Stop ${index + 1} location`}
                  value={stop.location}
                  onChange={(e) => onUpdateStop(index, 'location', e.target.value)}
                  onFocus={() => setShowStopSuggestions(index)}
                  onBlur={() => setTimeout(() => setShowStopSuggestions(-1), 200)}
                  className="border-gray-300 focus:border-orange-500 focus:ring-orange-500"
                />
                {showStopSuggestions === index && stop.location && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-48 overflow-y-auto">
                    {mockLocations.filter(loc => 
                      loc.toLowerCase().includes(stop.location.toLowerCase())
                    ).slice(0, 5).map((loc, idx) => (
                      <button
                        key={idx}
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center gap-2"
                        onClick={() => {
                          onUpdateStop(index, 'location', loc);
                          setShowStopSuggestions(-1);
                        }}
                      >
                        <MapPin className="h-4 w-4 text-gray-400" />
                        <span className="text-sm">{loc}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <select
                value={stop.duration}
                onChange={(e) => onUpdateStop(index, 'duration', parseInt(e.target.value))}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
              >
                <option value={3}>3 min</option>
                <option value={5}>5 min</option>
                <option value={10}>10 min</option>
                <option value={15}>15 min</option>
              </select>
              <button
                onClick={() => onRemoveStop(index)}
                className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default StopManager;
